import { useEffect } from "react";
import { X } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import { verifyClaim, clearClaimState } from "../../Redux/claimSlice";

const ClaimProfileModal = ({ isOpen, onClose, username, onSuccess }) => {
  const dispatch = useDispatch();
  const { loading, error } = useSelector((state) => state.claim);

  useEffect(() => {
    if (!isOpen) {
      dispatch(clearClaimState());
    }
  }, [isOpen, dispatch]);

  const handleClaim = async () => {
    if (!username) return;
    try {
      await dispatch(verifyClaim(username)).unwrap();
      onSuccess?.();
      onClose();
    } catch (_) {
      // error is already in state
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl w-full max-w-md p-6 shadow-xl">
        <div className="flex justify-between items-center mb-6">
          <h3 className="text-lg font-semibold">Claim your profile</h3>
          <button
            type="button"
            onClick={onClose}
            className="p-1 rounded-full hover:bg-gray-100"
            aria-label="Close"
          >
            <X size={20} />
          </button>
        </div>

        <p className="text-sm text-gray-600 mb-6">
          Your logged-in username must match <strong>@{username}</strong> to
          verify this profile and get the verified badge.
        </p>

        {error && (
          <p className="text-sm text-red-600 mb-4">{error}</p>
        )}

        <button
          type="button"
          onClick={handleClaim}
          disabled={loading}
          className="w-full py-3 rounded-xl font-medium bg-orange-500 text-white hover:bg-orange-600 disabled:opacity-50"
        >
          {loading ? "Verifying…" : "Claim Profile"}
        </button>
      </div>
    </div>
  );
};

export default ClaimProfileModal;
